<script setup>
import PencilSimpleIcon from '@iconify-vue/ph/pencil-simple';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import PillCell from '@js/components/tables/cells/PillCell.vue';
import TextCell from '@js/components/tables/cells/TextCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { useRoute } from '@js/utils/route';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    setGlobalFilter,
    availableFilters,
    filters,
    setFilters,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'fullTitle',
            header: () => 'Titre',
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.fullTitle,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'name',
            header: () => 'Nom',
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.name,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'type',
            header: () => 'Type',
            cell: (props) =>
                props.row.original.type
                    ? h(PillCell, {
                          pillValue: props.row.original.type,
                      })
                    : null,
        }),
        columnHelper.display({
            id: 'actions',
            header: 'Actions',
            cell: (props) =>
                h(
                    BaseCell,
                    {},
                    {
                        default: () =>
                            h(ActionButton, {
                                size: 'small',
                                square: true,
                                title: 'Modifier',
                                href: route('front.updateModule', {
                                    module: props.row.original.key,
                                }),
                                icon: PencilSimpleIcon,
                            }),
                    },
                ),
            width: 0,
        }),
    ],
    url: route('front.postModules'),
    columnPinning: {
        right: ['actions'],
    },
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :set-global-filter="setGlobalFilter"
        :available-filters="availableFilters"
        :filters="filters"
        :set-filters="setFilters"
        :loading="loading"
    />
</template>
